export default {
  'menu.welcome': 'خوش آمدید',
  'menu.home': 'خانه',
  'menu.login': 'ورود',

  // ماژول مدیریت سیستم
  'menu.system': 'مدیریت سیستم',
  'menu.system.welcome': 'خانه سیستم',
  'menu.system.dict': 'مدیریت دیکشنری',
  'menu.system.menu': 'مدیریت منو',
  'menu.system.role': 'مدیریت نقش',
  'menu.system.noAuth': 'رابط بدون احراز هویت',

  // ماژول مدیریت رویداد
  'menu.event': 'مدیریت رویداد',
  'menu.event.eventRecord': 'ثبت رویداد',
  'menu.event.eventOrder': 'سفارش رویداد',
  'menu.event.eventOrderNode': 'گره سفارش',
  'menu.event.eventReceiver': 'دریافت‌کننده رویداد',
  'menu.event.resourceFile': 'فایل منابع',

  // ماژول مدیریت سازمان
  'menu.organization': 'مدیریت سازمان',
  'menu.organization.orgDept': 'مدیریت دپارتمان',
  'menu.organization.orgPost': 'مدیریت موقعیت',
  'menu.organization.orgTree': 'ساختار سازمانی',
  'menu.organization.employee': 'مدیریت کارمندان',

  // ماژول مدیریت دستگاه
  'menu.device': 'مدیریت دستگاه',
  'menu.device.deviceModel': 'مدل دستگاه',
  'menu.device.deviceSupplier': 'تامین کننده دستگاه',
  'menu.device.deviceGateway': 'درگاه دستگاه',
  'menu.device.deviceTerminal': 'ترمینال دستگاه',
  'menu.device.deviceManagement': 'مدیریت دستگاه',

  // ماژول مدیریت بسته
  'menu.package': 'مدیریت بسته',
  'menu.package.myPackage': 'بسته های من',
  'menu.package.subPackage': 'زیر بسته',

  // مدیریت کاربر
  'menu.user': 'مدیریت کاربر',

  // ماژول ادغام ویدیو
  'menu.video': 'ادغام ویدیو',
  'menu.video.preview': 'پیش نمایش زنده',
  'menu.video.playback': 'پخش تاریخچه',
  'menu.video.recording': 'ضبط دستی',
};
